import { Field, FieldProps } from "formik";
import React, { ChangeEventHandler } from "react";

import styles from "./styles.module.scss";

interface ComponentProps {
  label: string;
  name: string;
  displayInput?: string;
  disabled?: boolean;
  bg?: string;
  value?: string;
  asterisk?: boolean;
  onChange?: ChangeEventHandler<HTMLSelectElement> | undefined;
  options?: React.ReactNode;
  placeholder?: string;
}

const Select: React.FC<ComponentProps> = (props) => {
  const {
    name,
    label,
    disabled,
    options,
    placeholder,
    onChange,
    asterisk = false,
    value,
  } = props;

  return (
    <Field name={name}>
      {({ field, meta }: FieldProps) => (
        <div className={styles.container}>
          <label className={styles.label}>
            {asterisk === true ? (
              <span>
                {label}
                <sup className={styles.asterisk}>*</sup>
              </span>
            ) : (
              label
            )}
          </label>

          <select
            {...field}
            value={value ?? field.value ?? ""}
            disabled={disabled}
            className={styles.select}
            onChange={(event) => {
              field.onChange(event);
              onChange?.(event);
            }}
            onBlur={field.onBlur}
          >
            {!meta.value && <option value="">{placeholder}</option>}
            {options}
          </select>

          {meta.touched && meta.error && (
            <div className={styles.error}>{meta.error}</div>
          )}
        </div>
      )}
    </Field>
  );
};

export default Select;
